export const HEALTH = {
  nickname: 'PRODUCTS.HEALTH.nickname',
  icon:'health'
};
